import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

export const useHealthlinkMessageQuery = (messageControlId) => {

  const tenantVal = localStorage.getItem("kinesin-tenant");

  return useQuery({
    queryKey: ["healthlinkMessageQuery", messageControlId, tenantVal],
    queryFn: async () => {
      const axiosInstance = createAxiosInstance();
      const response = await axiosInstance.get(
        `${tenantVal}/healthlink/messages/query?messageControlId=${messageControlId}`
      );

      return response.data;
    },
    enabled: !!messageControlId && !!tenantVal,
    meta: { errorMessage: "Error fetching Healthlink message" },
  });
};
